import hyperdom from 'hyperdom'
import BasePaymentMethod from './basePaymentMethod.jsx'

export default class Placeholder extends BasePaymentMethod{
  constructor (payment) {
    super(payment)
  }

  render () {
    return <div class='o-accent-box'>
      { this.payment.renderPaymentMethodSelection({noDetails: true}) }
    </div>
  }

  renderTermsAndConditions () {
  }

  renderPaymentSummary () {
  }
}
